import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {BlockService} from '../../../service/BlockService';
import {CommentFiche} from '../../../model/comment';
import {RoleService} from '../../../service/RoleService';
import {TimeZoneService} from '../../../service/TimeZoneService';

@Component({
  selector: 'modal-comment',
  templateUrl: './modal-comment.component.html',
  styleUrls: ['./modal-comment.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalCommentComponent implements OnInit {
  user: any;
  dateShift: any;
  creationDate: any;
  _send: boolean = false;
  isValid: boolean = false;
  commentText: string = '';
  comment: CommentFiche = new CommentFiche();

  constructor(public dialogRef: MatDialogRef<ModalCommentComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private roleService: RoleService,
              private tzService: TimeZoneService,
              private blockservice: BlockService) {
  }

  ngOnInit() {
    this.comment = this.data.commentFiche;
    if (this.comment && this.comment.creationDate)
      this.creationDate = this.tzService.GmtToLocale(this.comment.creationDate);
    this.user = this.data.user;
    this.dateShift = this.data.dateShift;
    this.commentText = this.data.commentFiche.text;
    this.isValid = this.data.isValid || !(this.roleService.isOps || this.roleService.isBUM || this.roleService.isTL || this.roleService.isDS);
  }

  public CloseDialog() {
    this.dialogRef.close();
  }

  save() {
    this._send = true;
    let comment: CommentFiche = new CommentFiche();
    comment.id = this.comment && this.comment.id ? this.comment.id : null;
    comment.text = this.commentText;
    comment.type = 'FICHE';
    comment.username = this.user;
    comment.toUpdate = true;
    comment.ficheDate = this.dateShift;

    this.blockservice.saveComments(comment)
      .subscribe(res => {
        this._send = false;
        this.dialogRef.close(true);
      });

  }

}





// WEBPACK FOOTER //
// ./src/app/modules/injection/modal-comment/modal-comment.component.ts